import PropTypes from 'prop-types';
import React from 'react';

import SvgIcon from '../SvgIcon';

const CheckboxIcon = ({ setRef, ...rest }) => (
    <SvgIcon {...rest} ref={setRef}>
        <path d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" />
    </SvgIcon>
);

CheckboxIcon.propTypes = {
    setRef: PropTypes.object,
    viewBox: PropTypes.string,
};

CheckboxIcon.defaultProps = {
    setRef: null,
    viewBox: '0 0 24 24',
};

export default CheckboxIcon;
